import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/syep14.png";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


function TechPal2() {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/registration#techpal-section"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            TECH-PALS<span className="purple"> AT CHOICEST FRUIT </span> 
            </h1>
            <p className="home-about-body">
                        The Tech-Pal Program is an international initiative of Choicest Fruit that connects 
                        young people across continents to learn, collaborate, and innovate. Through peer mentoring,
                        virtual internships, curriculum exchange, and capacity building, Tech-Pal empowers youth 
                        to grow as ethical leaders in technology while building stronger, interconnected communities
                        worldwide.
                        <br />
                        <br />
                        <h2>1. Tech-Pal Program (Peer Mentoring & Support)</h2>
                        <span className="purple">Objective:</span> Create cross-continental youth connections for skill-sharing, cultural exchange, and leadership development.
                         <li>Pair youth participants overseas with Choicest Fruit students for structured peer mentoring.</li>
                         <li>Monthly virtual check-ins, collaborative mini-projects, and reflection activities.</li>
                         <li>Showcase events where Tech-Pals present their projects to peers and partners.</li> 
                         <br/>  
                         <span className="purple">Outcomes:</span> Stronger global networks, confidence in communication, cultural exchange, and shared innovation experiences.                            
                        <br />
                        <br />
                        <h2>2. Virtual Internships & Project Work</h2>
                        <span className="purple">Objective:</span> Provide international career exposure through remote, project-based internships.
                         <li>Remote internships offered through Choicest Fruit and Austin-based partner companies.</li>
                         <li>Co-develop projects in coding, electronics, UX/UI design, and ethical tech.</li>
                         <li>Students gain mentorship from industry professionals while producing real-world deliverables.</li> 
                          <br />
                          <span className="purple">Outcomes: </span> Practical work experience, global career readiness, and expanded professional networks.
                          <br />
                          <br />
                          <h2>3. Curriculum Exchange & Adaptation</h2> 
                           <span className="purple">Objective: </span> Enrich educational programs by sharing best practices and adapting curricula to local contexts.
                          <li>Joint curriculum review sessions to align with cultural, national, and industry needs.</li>
                          <li>Blended learning pathways with co-taught lessons between organizations.</li>
                          <li>Localized adaptations to ensure relevance and accessibility.</li>                                                      
                        <br />
                         <span className="purple">Outcomes:</span> Enriched, context-relevant STEM education that reaches more students globally.
                           <br />
                            <br />
                           <h2>4. Training & Capacity Building</h2> 
                           <span className="purple">Objective:</span> Strengthen both student and instructor capabilities for long-term sustainability.
                          <li>Develop shared masterclasses in software development, cybersecurity, entrepreneurship, and innovation leadership.</li>
                          <li>Train Choicest Fruit Ambassadors in ethical tech development practices through partner expertise.</li>
                          <li>Train instructors in Choicest Fruit’s Ethical Tech Development Framework and modules.</li>                                                      
                        <br />
                        <span className="purple">Outcomes:</span> Empowered educators, scalable STEM programs, and sustainable global impact.
                           <br />
          </p>
          <Button onClick={handleClick}>Apply Here</Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>SUMMER INTERNSHIP PROGRAM</h1>
          <Container>    
        {/* Responsive Video */}
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                    title="YouTube video"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
                <h1>TESTIMONIALS</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default TechPal2;
